import React, { useEffect } from 'react';
import { Modal, Form, Input, DatePicker, Button, Switch } from 'antd';
import dayjs from 'dayjs';

const AddIoIndasData = ({ open, onCancel, onSubmit, initialData = null, setEditIoIndasData }) => {
        const [form] = Form.useForm();
        const isEditMode = initialData && Object.keys(initialData).length > 0;

        const handleOk = async () => {
                try {
                        const values = await form.validateFields();
                        const formattedValues = {
                                ...values,
                                IS_INDAS: values.IS_INDAS ? 1 : 0, // convert boolean to 1/0
                                UPTO_DATE: values.UPTO_DATE?.format('DD-MM-YYYY') || null,
                        };

                        const result = await onSubmit(formattedValues);

                        if (result?.status === 'success') {
                                form.resetFields();
                                setEditIoIndasData({});
                        }
                } catch (err) {
                        console.log('Validation or submission error:', err);
                }
        };

        useEffect(() => {
                if (initialData && isEditMode) {
                        const formattedData = {
                                ...initialData,
                                IS_INDAS: initialData.IS_INDAS === 1, // convert 1/0 to boolean
                                UPTO_DATE: initialData.UPTO_DATE
                                        ? dayjs(initialData.UPTO_DATE, 'DD-MM-YYYY')
                                        : null,
                        };

                        form.setFieldsValue(formattedData);
                } else {
                        form.resetFields();

                        form.setFieldsValue({
                                IS_INDAS: false,
                        });
                }
        }, [initialData, open]);

        const fields = [
                { label: 'IO Number', name: 'IO_NO', disabled: isEditMode },
                { label: 'Revision Number', name: 'REV_NO', disabled: isEditMode },
                { label: 'Unit Code', name: 'UNIT_CODE', disabled: isEditMode },
                { label: 'Cycle ID', name: 'CYCLE_ID' },
                { label: 'Allocation', name: 'ALLOCATION' },
                { label: 'TCR', name: 'TCR' },
                { label: 'TECC', name: 'TECC' },
                { label: 'CCI', name: 'CCI' },
                { label: 'Billed Upto', name: 'BILLED_UPTO' },
                { label: 'PVC', name: 'PVC' },
                { label: 'ERV', name: 'ERV' },
                { label: 'Revenue Recognised Upto', name: 'REVENUE_RECOGNISED_UPTO' },
                { label: 'Upto Date', name: 'UPTO_DATE', isDate: true },
                { label: 'INDAS PID', name: 'INDAS_PID', optional: true },
                { label: 'BS Unit', name: 'BS_UNIT', optional: true },
                { label: 'IS INDAS', name: 'IS_INDAS', isSwitch: true },
        ];

        return (
                <Modal
                        title={isEditMode ? 'Edit Order Allocation Data' : 'Add Order Allocation Data'}
                        open={open}
                        onCancel={() => {
                                form.resetFields();
                                onCancel();
                        }}
                        onOk={handleOk}
                        footer={[
                                <Button key="cancel" onClick={onCancel}>
                                        Cancel
                                </Button>,
                                <Button key="submit" type="primary" onClick={handleOk}>
                                        {isEditMode
                                                ? 'Update Order Allocation Data'
                                                : 'Add Order Allocation Data'}
                                </Button>,
                        ]}
                        width={600}>
                        <Form
                                form={form}
                                layout="vertical"
                                className="custom-form-scroll"
                                style={{ maxHeight: '50vh', overflowY: 'auto' }}>
                                {fields.map(({ label, name, isDate, disabled, optional, isSwitch }) => (
                                        <Form.Item
                                                key={name}
                                                name={name}
                                                valuePropName={isSwitch ? 'checked' : 'value'}
                                                label={
                                                        <div className="flex justify-between items-center gap-2">
                                                                <label className="text-left pr-4">
                                                                        {label}
                                                                        {!optional && (
                                                                                <span className="text-red-500">*</span>
                                                                        )}
                                                                </label>
                                                        </div>
                                                }
                                                labelCol={{ span: 7 }}
                                                wrapperCol={{ span: 14 }}
                                                layout="horizontal"
                                                required={false}
                                                rules={
                                                        optional
                                                                ? []
                                                                : [
                                                                        {
                                                                                required: true,
                                                                                message: `${label} is required`,
                                                                        },
                                                                ]
                                                }>
                                                {isDate ? (
                                                        <DatePicker
                                                                format="DD-MM-YYYY"
                                                                className="w-full"
                                                        />
                                                ) : isSwitch ? (
                                                        <Switch />
                                                ) : (
                                                        <Input
                                                                className="w-full"
                                                                disabled={disabled}
                                                        />
                                                )}
                                        </Form.Item>
                                ))}
                        </Form>
                </Modal>
        );
};

export default AddIoIndasData;